import { IStyle } from '@fluentui/react';

export interface IRadialChartStyles {
  root: IStyle;
}

export interface IRadialChartClassNames {
  root: string;
}

export const radialChartStylesDefault: Partial<IRadialChartStyles> = {
  root: {
    height: '100%',
  },
};
